import { ColumnOrderState, VisibilityState } from '@tanstack/react-table';

import { TABLE_COLUMN_ORDER_STORAGE_KEY_PREFIX, TABLE_COLUMN_VISIBILITY_STORAGE_KEY_PREFIX } from '../types/table';
import { isRecordOf, readTableStorage } from './tableStorage';

const isVisibilityState = isRecordOf((visible): visible is boolean => typeof visible === 'boolean');

const isColumnOrderState = (value: unknown): value is ColumnOrderState =>
    Array.isArray(value) && value.every((id) => typeof id === 'string');

export const getStoredColumnVisibility = (tableName?: string): VisibilityState =>
    readTableStorage(TABLE_COLUMN_VISIBILITY_STORAGE_KEY_PREFIX, tableName, isVisibilityState, {});

export const getStoredColumnOrder = (tableName?: string): ColumnOrderState =>
    readTableStorage(TABLE_COLUMN_ORDER_STORAGE_KEY_PREFIX, tableName, isColumnOrderState, []);
